import React from "react";

export default function PluralityExplanation(isNew) {
  return (
    <>
      {!isNew && (
        <p className="caveat">
          <b>NOTE</b>:{" "}
          <i>
            You have already voted in this election. If you vote multiple times,
            only your last vote will be considered in the election results.
          </i>
        </p>
      )}
      <p>
        Our tour of voting methods begins with <b>plurality voting</b>. You get
        one vote. The candidate with the most votes wins.
      </p>
      <p>
        These are the candidates shortlisted by the Biden campaign, according to{" "}
        <a
          href="https://apnews.com/cfb9f51767aeee83f1f426fb42070a9e"
          target="_blank"
          rel="noopener noreferrer"
        >
          AP on June 12<sup>th</sup>
        </a>
        .
      </p>
      <p className="nextAction">
        Try it. Pick your favorite candidate, then click Vote.
      </p>
    </>
  );
}
